enum ActionTypesEnum {
  // Data Sources
  ADD_DATASOURCE = 'ADD_DATASOURCE',
  REMOVE_DATASOURCE = 'REMOVE_DATASOURCE',
  EDIT_DATASOURCE = 'EDIT_DATASOURCE',

  GET_DATASOURCE_DETAIL = 'GET_DATASOURCE_DETAIL',
  SET_DATASOURCE_DETAIL = 'SET_DATASOURCE_DETAIL',
  CANCEL_DATASOURCE_DETAIL = 'CANCEL_DATASOURCE_DETAIL',
  TEST_CONNECTION = 'TEST_CONNECTION',

  CLOSE_MODAL = 'CLOSE_MODAL',
  CLOSE_DROPDOWN = 'CLOSE_DROPDOWN',

  ADD_DASHBOARD = 'ADD_DASHBOARD',
  UPDATE_DASHBOARD = 'UPDATE_DASHBOARD',
  DASHBOARD_TYPE_SELECTED = 'DASHBOARD_TYPE_SELECTED',
  INSTALL_ADDON = 'INSTALL_ADDON',
  TOGGLE_DASHBOARD_EDITABLE = 'TOGGLE_DASHBOARD_EDITABLE',
  DASHBOARD_FORM_FIELDS = 'DASHBOARD_FORM_FIELDS',
  TOGGLE_KIOSK_MODE = 'TOGGLE_KIOSK_MODE',
  EDIT_DASHBOARD = 'EDIT_DASHBOARD',

  // Addon
  CREATE_ADDON = 'CREATE_ADDON',

  // Widgets
  CREATE_WIDGET = 'CREATE_WIDGET',
  ADDON_CREATE_WIDGET = 'ADDON_CREATE_WIDGET',
  EDIT_WIDGET = 'EDIT_WIDGET',
  UPDATE_WIDGET = 'UPDATE_WIDGET',
  DELETE_WIDGET = 'DELETE_WIDGET',
  WIDGET_CREATE_FIELD_SELECTED = 'WIDGET_CREATE_FIELD_SELECTED',
  WIDGET_CREATE_ONE_ITEM_SELECTED = 'WIDGET_CREATE_ONE_ITEM_SELECTED',
  WIDGET_ADDED = 'WIDGET_ADDED',
  WIDGET_DELETED = 'WIDGET_DELETED',
  UPDATE_WIDGET_DATA = 'UPDATE_WIDGET_DATA',
  UPDATE_WIDGET_DATE = 'UPDATE_WIDGET_DATE',
  UPDATE_WIDGET_NOTE = 'UPDATE_WIDGET_NOTE',
  UPDATE_SCREENSHOT = 'UPDATE_SCREENSHOT',
  DUPLICATE_WIDGET = 'DUPLICATE_WIDGET',

  // Layout
  GRID_LAYOUT_CHANGED = 'GRID_LAYOUT_CHANGED',
  STORE_LAYOUT_CHANGE = 'STORE_LAYOUT_CHANGE',

  // User
  LOG_OUT = 'LOG_OUT',

  // Profile
  UPDATE_AVATAR = 'UPDATE_AVATAR',

  // Collapse
  CHANGE_COLLAPSE = 'CHANGE_COLLAPSE',

  // Developers and Teams
  CREATE_DEVELOPER = 'CREATE_DEVELOPER',
  UPDATE_DEVELOPER = 'UPDATE_DEVELOPER',
  CREATE_TEAM = 'CREATE_TEAM',
  UPDATE_TEAM = 'UPDATE_TEAM',

  // Notifications
  CREATE_NOTIFICATION = 'CREATE_NOTIFICATION',
  UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION',
  SEND_NOTIFICATION = 'SEND_NOTIFICATION',

  SEND_TSC_INFORMATION = 'SEND_TSC_INFORMATION',
  AGILE_SPACE_DATE_EVENT = 'AGILE_SPACE_DATE_EVENT',
  PULL_REQUEST_DATE_EVENT = 'PULL_REQUEST_DATE_EVENT',
  DORA_DATE_EVENT = 'DORA_DATE_EVENT',
  SCORECARD_DATE_EVENT = 'SCORECARD_DATE_EVENT',
  GIT_ANALYTICS = 'GIT_ANALYTICS',


  // Gitwiser
  ADD_ANALYSIS = 'ADD_ANALYSIS',
  UPDATE_ANALYSIS = 'UPDATE_ANALYSIS',
  CANCEL_ANALYSIS = 'CANCEL_ANALYSIS',
  SHOW_NEW_ANALYSIS_MODAL = 'SHOW_NEW_ANALYSIS_MODAL',
  ANALYSIS_CREATE_FIELD_SELECTED = 'ANALYSIS_CREATE_FIELD_SELECTED',
  ANALYSIS_CREATE_V2_FIELD_SELECTED = 'ANALYSIS_CREATE_V2_FIELD_SELECTED',
  NEXT_DATA_STEP_DATA = 'NEXT_DATA_STEP_DATA',
  LOAD_INITIAL_ANALYSIS = 'LOAD_INITIAL_ANALYSIS',
  ANALYSIS_CREATE_FIELD_KEYUP_ACTION = 'ANALYSIS_CREATE_FIELD_KEYUP_ACTION',
  ANALYSIS_UPDATE_FIELD_SELECTED = 'ANALYSIS_UPDATE_FIELD_SELECTED',
  BACK_TO_SCOPE_MODAL = 'BACK_TO_SCOPE_MODAL',
  READY_TO_REANALYSE = 'READY_TO_REANALYSE',
  READY_TO_PRA_REANALYSE = 'READY_TO_PRA_REANALYSE',
  RETURN_PR_DATA = 'RETURN_PR_DATA',
  RETURN_DEPLOYMENT_DATA = 'RETURN_DEPLOYMENT_DATA',
  EXCLUDE_PR = 'EXCLUDE_PR',
  EXCLUDE_COMMIT = 'EXCLUDE_COMMIT',

  ADD_DEPLOYMENT_ANALYTICS = 'ADD_DEPLOYMENT_ANALYTICS',
  UPDATE_DEPLOYMENT_ANALYTICS = 'UPDATE_DEPLOYMENT_ANALYTICS',
  CHANGE_STATUS_DEPLOYMENT_DURING = 'CHANGE_STATUS_DEPLOYMENT_DURING',
  ADD_MULTIPLE_DEPLOYMENT_ANALYTICS = 'ADD_MULTIPLE_DEPLOYMENT_ANALYTICS',

  // Qwiser
  SHOW_NEW_ANALYSIS_QWISER_MODAL = 'SHOW_NEW_ANALYSIS_QWISER_MODAL',

  // Agile Space
  ADD_AGILE_ANALYSIS = 'ADD_AGILE_ANALYSIS',
  UPDATE_AGILE_ANALYSIS = 'UPDATE_AGILE_ANALYSIS',
  CANCEL_AGILE_ANALYSIS = 'CANCEL_AGILE_ANALYSIS',
  ADD_V2_AGILE_ANALYSIS = 'ADD_V2_AGILE_ANALYSIS',
  UPDATE_V2_AGILE_ANALYSIS = 'UPDATE_V2_AGILE_ANALYSIS',

  // Durations
  UPDATE_DURATIONS_DATE = 'UPDATE_DURATIONS_DATE',

  // Delete Confirm
  DELETE_CONFIRM = 'DELETE_CONFIRM',
  SHOW_DELETE_CONFIRM_MODAL = 'SHOW_DELETE_CONFIRM_MODAL',

  // Admin
  IMPORT_FROM_LDAP = 'IMPORT_FROM_LDAP',
  IMPORT_FROM_AZURE = 'IMPORT_FROM_AZURE',
  LDAP_SEARCH_CHANGE = 'LDAP_SEARCH_CHANGE',
  AZURE_SEARCH_CHANGE = 'AZURE_SEARCH_CHANGE',
  SHOW_INFORMATION_ICONS = 'SHOW_INFORMATION_ICONS',

  // Developer List Popup
  UPDATE_DEVELOPER_POPUP = 'UPDATE_DEVELOPER_POPUP',
  DELETE_DEVELOPER_POPUP = 'DELETE_DEVELOPER_POPUP',

  // Initialize Team Scorecard
  NEXT_STEP_DATA = 'NEXT_STEP_DATA',
  UPDATE_INITIALIZE_TEAM_SCORE_CARD_DATA = 'UPDATE_INITIALIZE_TEAM_SCORE_CARD_DATA',
  CREATE_TEAM_SCORECARD = 'CREATE_TEAM_SCORECARD',
  CREATE_TEAM_SCORECARD_SUCCESS = 'CREATE_TEAM_SCORECARD_SUCCESS',
  CREATE_TEAM_SCORECARD_ERROR = 'CREATE_TEAM_SCORECARD_ERROR',
  GET_BRANCH_DATA = 'GET_BRANCH_DATA',

  // Portfolio
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  UPDATE_PRODUCT = 'UPDATE_PRODUCT',
  CREATE_COMPONENT = 'CREATE_COMPONENT',
  UPDATE_COMPONENT = 'UPDATE_COMPONENT',
  GET_ITEM_TEMPLATES = 'GET_ITEM_TEMPLATES',
  CREATE_ITEM = 'CREATE_ITEM',
  UPDATE_ITEM = 'UPDATE_ITEM',
  ITEM_FIELD_SELECTED = 'ITEM_FIELD_SELECTED',

  // Leagues
  CREATE_KPI = 'CREATE_KPI',
  UPDATE_KPI = 'UPDATE_KPI',
  CREATE_LEAGUE = 'CREATE_LEAGUE',
  UPDATE_LEAGUE = 'UPDATE_LEAGUE',
  ADD_KPI_LIST = 'ADD_KPI_LIST',
  CREATE_GROUP = 'CREATE_GROUP',
  UPDATE_GROUP = 'UPDATE_GROUP',

  // Report
  CREATE_REPORT = 'CREATE_REPORT',
  UPDATE_REPORT = 'UPDATE_REPORT',
  SEND_TEST_REPORT = 'SEND_TEST_REPORT',

  // Tutorial Mode
  TUTORIAL_MODE = 'TUTORIAL_MODE',

  // Admin
  IMPORT_USER_LIST = 'IMPORT_USER_LIST',
  CHANGE_FEATURE = 'CHANGE_FEATURE',
  UPDATE_LDAP = 'UPDATE_LDAP',

  // Date Range Picker
  PICKER_SELECTED_RANGE ='PICKER_SELECTED_RANGE',

  // Excel Export
  EXCEL_EXPORT_TEAM_SCORE_CARD ='EXCEL_EXPORT_TEAM_SCORE_CARD',
  EXCEL_EXPORT_TEAM_SCORE_LOADING ='EXCEL_EXPORT_TEAM_SCORE_LOADING',
  EXCEL_EXPORT_TEAM_SCORE_UNLOADING ='EXCEL_EXPORT_TEAM_SCORE_UNLOADING',

  // Excel Developer Export
  EXCEL_EXPORT_DEVELOPER_SCORE_CARD = 'EXCEL_EXPORT_DEVELOPER_SCORE_CARD',

  // User Settings
  CHANGE_MENU_STYLE = 'CHANGE_MENU_STYLE',

  // Excel Export Quality
  EXCEL_EXPORT_QUALITY ='EXCEL_EXPORT_QUALITY',

}

export default ActionTypesEnum;
